
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.492 16.7c3.9 0 6.1 3.3 6.5 6.7 0 .1.025.225.05.35.025.125.05.25.05.35 0 .3 0 .6-.1.8-.5 3.5-2.8 6.8-6.8 6.6-3.8-.2-6.2-3.8-6.2-7.4 0-3.7 2.5-7.4 6.5-7.4zm-5.1 7.5c0-5.6 10-5.6 10.3 0-.3 5.6-10.3 5.6-10.3 0z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30.092 7c13.2 0 19.3 14.4 14.4 25.3-.1.3-.2.6-.4.8-3.7 6.9-8.3 14.1-13.7 19.8-.2.3-.5.3-.7 0-5.5-5.9-10.1-13.2-13.9-20.2v-.1c-5.1-11 1-25.6 14.3-25.6zm-5.184 36.1c1.424 2.223 4.292 6.7 5.184 6.7.94 0 3.78-4.414 5.352-6.857.436-.678.774-1.204.948-1.443 2.5-3.5 4.9-7.2 7-11 4.6-9.9-2.9-20.3-13.3-20.3s-17.9 10.4-13.3 20.2c2.2 4.1 4.7 7.9 7.4 11.6.132.189.385.584.716 1.1z"}})])
          )
        }
      }
    